import axios from "axios";


const URL_BASE = `${process.env.ROOT_API}/pessoa`;

export default class PessoaService{
	static cadastrarPessoa(form) {
		return axios.post(`${URL_BASE}/cadastrar`, form);
	}
	static atualizarPessoa(form, id) {
		return axios.put(`${URL_BASE}/atualizar/` + id, form);
	}
	static consultarPessoaPorId(id) {
		return axios.get(`${URL_BASE}/consultar/` + id);
	}
	static excluirPessoa(id, idUsuarioResponsavel) {
		return axios.delete(`${URL_BASE}/deletar/` + id + "?idUsuarioResponsavel=" + idUsuarioResponsavel);
	}
	static filtrarPessoasFisicas(query) {
		return axios.get(`${URL_BASE}/filtrarPessoaFisica?query=` + query);
	}
	static filtrarPessoasJuridicas(query) {
		return axios.get(`${URL_BASE}/filtrarPessoaJuridica?query=` + query);
	}

	static consultarPessoas(
		tipoPessoa = "",
		cpf = "",
		cnpj = "",
		pagina = 0,
		pessoasPorPagina = 15) {
		return axios.get(
			URL_BASE + "/consultar"
			+ "?tipoPessoa=" + tipoPessoa
			+ "&cpf=" + cpf
			+ "&cnpj=" + cnpj
			+ "&pagina=" + pagina
			+ "&pessoasPorPagina=" + pessoasPorPagina,
		);
	}
}



// WEBPACK FOOTER //
// ./src/service/PessoaService.js